<template>
  <v-form v-model="isFormValid">
    <v-text-field
      required
      outlined
      dense
      data-private
      class="body2"
      data-testid="createAccount-input-email"
      v-model="account.email"
      append-icon="mdi-lock"
      disabled
      :label="`${$t('auth.register.email')}*`"
      :rules="[name => !!name || $t('validation.form.this_field_is_required')]"
      @input="$emit('onChange', $event, 'email')"
      @blur="$emit('onBlur', $event, 'email')"
    ></v-text-field>

    <AddPassword
      testId="createAccount-input-password"
      :password="form.password"
      :confirmPassword="form.confirmPassword"
      @change="handlePasswordChange"
    />

    <Button
      block
      size="large"
      data-testid="createAccount-button-next"
      class="mt-6 mb-3"
      color="primary"
      :disabled="!isFormValid"
      :text="$t('auth.access.restore_password')"
      @click="onSubmit"
    />
  </v-form>
</template>

<script>
import Button from '@/components/UI/Button'
import AddPassword from '@/components/AddPassword.vue'

export default {
  name: 'ResetPasswordForm',
  props: {
    account: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isFormValid: false,
      form: {
        password: '',
        confirmPassword: '',
      },
    }
  },

  components: {
    AddPassword,
    Button,
  },

  methods: {
    handlePasswordChange(payload) {
      this.form = { ...this.form, ...payload }
      if (payload.password) {
        this.$emit('onPasswordUpdated', this.form.password)
      }
    },

    onSubmit() {
      this.$emit('onSubmit', this.account)
    },
  },
}
</script>
